import { styled } from '@vw-marketing/us-components';

export const ResultSectionContainer: any = styled.div`
  width: 100%;
  border-bottom: solid 1px #dfe4e8;
  margin-top: 50px;
`;
